// extracted by mini-css-extract-plugin
module.exports =  {"container":"_32bbee5fda--container--zSP0H","icon":"_32bbee5fda--icon--XSDnz","remoteness":"_32bbee5fda--remoteness--FvdoZ"};